import type { WindowType } from "../../consts/windowConsts"

export type WindowResizeAction = {
  type: "WINDOW_RESIZE"
  windowType: WindowType
}

export function resize(windowType: WindowType): WindowResizeAction {
  return {
    type: "WINDOW_RESIZE",
    windowType,
  }
}
